import angular from 'angular';

import WorkflowController from './workflow.controller';
import './workflow.scss';

export default angular
	.module('app.workflow', [])
	.controller('WorkflowController', WorkflowController)
	.name;
